function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { variables } from 'swag-client-common/styles/variables-js';
import BlockHeader from 'swag-client-common/components/ui/block-header';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './top-products.scss';
import TopProductsItem from './components/top-products-item';
const TopProducts = ({
  topProductsCount
}) => {
  const topProductsPropsList = [{
    className: 'drinkware',
    title: 'Drinkware',
    text: `${topProductsCount.drinkware} styles to choose from`,
    link: `${APP_ROUTES.COLLECTIONS}/drinkware`,
    colorList: {
      button: variables.colorPrimary,
      bgc: variables.colorSecondary
    },
    offset: 130
  }, {
    className: 'bags',
    title: 'Bags',
    text: `${topProductsCount.bags} styles to choose from`,
    link: `${APP_ROUTES.COLLECTIONS}/bags`,
    colorList: {
      button: variables.colorSecondary,
      bgc: variables.colorPrimary
    },
    offset: 130
  }, {
    className: 'office',
    title: 'Office',
    text: `${topProductsCount.office} styles to choose from`,
    link: `${APP_ROUTES.COLLECTIONS}/office`,
    colorList: {
      button: variables.colorSecondary,
      bgc: variables.colorAlternativePrimary
    },
    offset: 130
  }, {
    className: 'tech',
    title: 'Tech',
    text: `${topProductsCount.tech} styles to choose from`,
    link: `${APP_ROUTES.COLLECTIONS}/tech`,
    colorList: {
      button: variables.colorSecondary,
      bgc: '#ffa051'
    },
    offset: 130
  }, {
    className: 'apparel',
    title: 'Apparel',
    text: `${topProductsCount.apparel} styles to choose from`,
    link: `${APP_ROUTES.COLLECTIONS}/apparel`,
    colorList: {
      button: variables.colorSecondary,
      bgc: '#70bf56'
    },
    offset: 130
  }];
  return /*#__PURE__*/React.createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React.createElement(BlockHeader, {
    textClassName: classes.header
  }, "Top products"), /*#__PURE__*/React.createElement("div", {
    className: classes.innerContainer
  }, topProductsPropsList.map((topProductItemProps, index) => /*#__PURE__*/React.createElement(TopProductsItem, _extends({
    key: index
  }, topProductItemProps)))));
};
export default TopProducts;